<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <h2 class="m-0 h1 text-uppercase">
                    {{ $t('parcelas.resumen_compra') }}
                </h2>
                <h3 class="subtitle h3 light mb-3">{{ $t('parcelas.revisa_datos') }}</h3>
            </b-col>
            <b-col cols="12">
                <ResumenCompra 
                    :datosParcelas="datosParcelas"
                    :zona="zona"
                    :jet_id="jet_id"
                    :formulario="formulario"
                    @terminado="$emit('terminado')"
                    @cambiarDatos="cambiarDatos"
                />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ResumenCompra from './ResumenCompra';

    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            zona: {
                type: Object,
                required: true
            },
            jet_id: String,
            formulario: String
        },
        components: {
            ResumenCompra
        },
        methods: {
            cambiarDatos() {
                this.$emit('cambiarDatos');
            }
        }
    }
</script>